// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2938":"49191b175dd2c748","4273":"1993e8127ee77605","4396":"56734ed0a3d5da98","4884":"88c9da7f1fddd069","6020":"6384e9cad2ecf0b2","6198":"6735158b7ac15c1c"}[chunkId] + ".js";
};